import { GetStaticPaths } from 'next';
import TopicHub, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default TopicHub;
